import { TaskStatus, TaskStatusDescriptions } from "../models";

export const taskStatusToText = (status: TaskStatus): string => {
  return TaskStatusDescriptions[status];
};
